// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 책마다 등장 시점과 떠다니는 속도를 다르게 설정한다. */
.book {
  --enter-delay: 0ms;
  --float-duration: 3.8s;
  --float-path: book-drift-right;
}

.book:nth-child(1) { --enter-delay: 100ms; --float-duration: 3.2s; --float-path: book-drift-right; }
.book:nth-child(2) { --enter-delay: 180ms; --float-duration: 4.1s; --float-path: book-drift-left; }
.book:nth-child(3) { --enter-delay: 260ms; --float-duration: 3.6s; --float-path: book-drift-high; }
.book:nth-child(4) { --enter-delay: 340ms; --float-duration: 4.4s; --float-path: book-drift-right; }
.book:nth-child(5) { --enter-delay: 420ms; --float-duration: 3.4s; --float-path: book-drift-left; }
.book:nth-child(6) { --enter-delay: 500ms; --float-duration: 4s; --float-path: book-drift-high; }
.book:nth-child(7) { --enter-delay: 580ms; --float-duration: 3.7s; --float-path: book-drift-right; }

/* 1단계: 아래에 있던 책이 원래 위치로 등장한다. */
.book-entry {
  opacity: 0;
  transform: translateY(50px);
  animation: book-enter 700ms ease-out var(--enter-delay) forwards;
}

/* 2단계: 등장이 끝난 뒤 책이 계속 위아래로 움직인다. */
.book-float {
  display: block;
  border-radius: 4px;
  outline: 1px solid #ffffff2e;
  outline-offset: -0.5px;
  box-shadow: 18px 24px 34px #000000d9, -3px -3px 10px #ffffff14;
  cursor: pointer;
  will-change: transform;
  animation: var(--float-path) var(--float-duration) ease-in-out infinite;
  animation-delay: calc(var(--enter-delay) + 700ms);
}

.book-float:hover {
  animation-play-state: paused;
}

.book img {
  width: 100%;
  transition:
    transform 250ms ease,
    filter 250ms ease;
}

.book a:hover img {
  transform: scale(1.06);
  filter: brightness(1.12);
}

.popular-books .book:hover {
  z-index: 100;
}

@keyframes book-enter {
  from {
    opacity: 0;
    transform: translateY(50px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes book-drift-right {
  0%, 100% {
    transform: translateY(0);
  }

  25% {
    transform: translate(12px, -16px) rotate(1.5deg);
  }

  52% {
    transform: translate(-5px, -34px) rotate(-1deg);
  }

  78% {
    transform: translate(-13px, -11px) rotate(-1.5deg);
  }
}

@keyframes book-drift-left {
  0%, 100% {
    transform: translateY(0);
  }

  22% {
    transform: translate(-14px, -13px) rotate(-1.4deg);
  }

  55% {
    transform: translate(6px, -30px) rotate(1.2deg);
  }

  80% {
    transform: translate(12px, -8px) rotate(1deg);
  }
}

@keyframes book-drift-high {
  0%, 100% {
    transform: translateY(0);
  }

  30% {
    transform: translate(-8px, -26px) rotate(-1deg);
  }

  62% {
    transform: translate(10px, -42px) rotate(1.4deg);
  }

  84% {
    transform: translate(5px, -12px) rotate(0.5deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .book-entry,
  .book-float {
    animation: none;
  }

  .book-entry {
    opacity: 1;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/IntroPage/components/PopularBooks/IntroInteraction.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,qBAAqB,oBAAoB,EAAE,sBAAsB,EAAE,8BAA8B,EAAE;AACnG,qBAAqB,oBAAoB,EAAE,sBAAsB,EAAE,6BAA6B,EAAE;AAClG,qBAAqB,oBAAoB,EAAE,sBAAsB,EAAE,6BAA6B,EAAE;AAClG,qBAAqB,oBAAoB,EAAE,sBAAsB,EAAE,8BAA8B,EAAE;AACnG,qBAAqB,oBAAoB,EAAE,sBAAsB,EAAE,6BAA6B,EAAE;AAClG,qBAAqB,oBAAoB,EAAE,oBAAoB,EAAE,6BAA6B,EAAE;AAChG,qBAAqB,oBAAoB,EAAE,sBAAsB,EAAE,8BAA8B,EAAE;;AAEnG,gCAAgC;AAChC;EACE,UAAU;EACV,2BAA2B;EAC3B,gEAAgE;AAClE;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,8DAA8D;EAC9D,eAAe;EACf,sBAAsB;EACtB,uEAAuE;EACvE,iDAAiD;AACnD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX;;qBAEmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,kDAAkD;EACpD;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":["/* 책마다 등장 시점과 떠다니는 속도를 다르게 설정한다. */\n.book {\n  --enter-delay: 0ms;\n  --float-duration: 3.8s;\n  --float-path: book-drift-right;\n}\n\n.book:nth-child(1) { --enter-delay: 100ms; --float-duration: 3.2s; --float-path: book-drift-right; }\n.book:nth-child(2) { --enter-delay: 180ms; --float-duration: 4.1s; --float-path: book-drift-left; }\n.book:nth-child(3) { --enter-delay: 260ms; --float-duration: 3.6s; --float-path: book-drift-high; }\n.book:nth-child(4) { --enter-delay: 340ms; --float-duration: 4.4s; --float-path: book-drift-right; }\n.book:nth-child(5) { --enter-delay: 420ms; --float-duration: 3.4s; --float-path: book-drift-left; }\n.book:nth-child(6) { --enter-delay: 500ms; --float-duration: 4s; --float-path: book-drift-high; }\n.book:nth-child(7) { --enter-delay: 580ms; --float-duration: 3.7s; --float-path: book-drift-right; }\n\n/* 1단계: 아래에 있던 책이 원래 위치로 등장한다. */\n.book-entry {\n  opacity: 0;\n  transform: translateY(50px);\n  animation: book-enter 700ms ease-out var(--enter-delay) forwards;\n}\n\n/* 2단계: 등장이 끝난 뒤 책이 계속 위아래로 움직인다. */\n.book-float {\n  display: block;\n  border-radius: 4px;\n  outline: 1px solid #ffffff2e;\n  outline-offset: -0.5px;\n  box-shadow: 18px 24px 34px #000000d9, -3px -3px 10px #ffffff14;\n  cursor: pointer;\n  will-change: transform;\n  animation: var(--float-path) var(--float-duration) ease-in-out infinite;\n  animation-delay: calc(var(--enter-delay) + 700ms);\n}\n\n.book-float:hover {\n  animation-play-state: paused;\n}\n\n.book img {\n  width: 100%;\n  transition:\n    transform 250ms ease,\n    filter 250ms ease;\n}\n\n.book a:hover img {\n  transform: scale(1.06);\n  filter: brightness(1.12);\n}\n\n.popular-books .book:hover {\n  z-index: 100;\n}\n\n@keyframes book-enter {\n  from {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes book-drift-right {\n  0%, 100% {\n    transform: translateY(0);\n  }\n\n  25% {\n    transform: translate(12px, -16px) rotate(1.5deg);\n  }\n\n  52% {\n    transform: translate(-5px, -34px) rotate(-1deg);\n  }\n\n  78% {\n    transform: translate(-13px, -11px) rotate(-1.5deg);\n  }\n}\n\n@keyframes book-drift-left {\n  0%, 100% {\n    transform: translateY(0);\n  }\n\n  22% {\n    transform: translate(-14px, -13px) rotate(-1.4deg);\n  }\n\n  55% {\n    transform: translate(6px, -30px) rotate(1.2deg);\n  }\n\n  80% {\n    transform: translate(12px, -8px) rotate(1deg);\n  }\n}\n\n@keyframes book-drift-high {\n  0%, 100% {\n    transform: translateY(0);\n  }\n\n  30% {\n    transform: translate(-8px, -26px) rotate(-1deg);\n  }\n\n  62% {\n    transform: translate(10px, -42px) rotate(1.4deg);\n  }\n\n  84% {\n    transform: translate(5px, -12px) rotate(0.5deg);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .book-entry,\n  .book-float {\n    animation: none;\n  }\n\n  .book-entry {\n    opacity: 1;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
